module.exports = __webpack_public_path__ + "static/media/histopathology_1.d3ecdb9e.jpeg";